import { render, staticRenderFns } from "./TaxesAndFees.vue?vue&type=template&id=05fcaffb&scoped=true"
import script from "./TaxesAndFees.vue?vue&type=script&lang=js"
export * from "./TaxesAndFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fcaffb",
  null
  
)

export default component.exports